import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import MainHeader from './MainHeader';
import styles from './MainHeader.styles';

export default compose(
  withStyles(styles),
  withRouter,
)(MainHeader);
